import {Button} from 'platform/components';
import {Box} from 'platform/foundation';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

interface ExpandToggleProps extends TestIdProps {
  isExpanded: boolean;
  /** Label while collapsed, e.g. "Show all (85)". */
  expandLabel: string;
  onToggle: () => void;
}

/** The one show more / show less control of the listing preview, so all sections look the same. */
export function ExpandToggle(props: ExpandToggleProps) {
  // A block wrapper keeps the link button at its own width; as a direct child of a stack it would
  // stretch across the card and centre its label.
  return (
    <Box>
      <Button
        variant="link"
        size="small"
        title={props.isExpanded ? i18n.t('general.actions.showLess') : props.expandLabel}
        rightIcon={props.isExpanded ? 'navigation/expand_less' : 'navigation/expand_more'}
        onClick={props.onToggle}
        aria-expanded={props.isExpanded}
        data-testid={props['data-testid']}
      />
    </Box>
  );
}
